import { Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { ICurrency } from 'src/app/shared/model/currency.model';
import { PaymentService, UtilService, VariablesService } from 'src/app/shared/services';
import { CurrencyComponent } from '../currency/currency.component';
import { RippleDirective } from 'src/app/shared/directives/ripple/ripple.directive';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-currency-dropdown',
  imports: [
    MatMenuModule,
    RippleDirective,
    CurrencyComponent,
    IconComponent
  ],
  templateUrl: './currency-dropdown.component.html',
  styleUrls: ['./currency-dropdown.component.scss']
})
export class CurrencyDropdownComponent {
  vars = inject(VariablesService);
  utils = inject(UtilService);
  readonly payments = inject(PaymentService);

  readonly type = input<'symbol' | 'text'>('symbol');
  readonly theme = input<'' | 'theme1' | 'theme2' | 'theme3'>('');
  readonly selectedCurrency = input<string | undefined>(undefined);
  readonly currencyList = input<ICurrency[] | undefined>(undefined);

  readonly onCurrencyChange = output<string>();

  readonly currentCurrency = signal('');
  readonly supportedCurrencies = computed(() => this.currencyList() || this.vars.supportedCurrency());

  constructor() {
    effect(() => {
      this.currentCurrency.set(this.selectedCurrency() || this.vars.currency());
    });
  }

  setCurrency(currency: string) {
    this.currentCurrency.set(currency);
    this.onCurrencyChange.emit(currency);
  }
}
